const addPaymentMethod = 'add payment method';
export const PAGE_FUNCTION = {
    MAKE_PAYMENT: {
        PAYMENTS: 'payments',
        AUTOPAY: 'autopay'
    }
};
/**
 * Return sub function tags of each module
 */
export const SUB_FUNCTION = {
    PAYMENT_METHOD: {
        ADD_PAYMENT_METHOD: addPaymentMethod,
        ADD_PAYMENT_METHOD_CHECKING: 'add payment method:checking',
        ADD_PAYMENT_METHOD_SAVINGS: 'add payment method:savings',
        ADD_PAYMENT_METHOD_DEBIT: 'add payment method:debitcard',
        ADD_PAYMENT_METHOD_CREDIT: 'add payment method:creditcard'
    },
    MAKE_PAYMENT: {
        PAID_OFF: 'paid off',
        PAYMENT: 'makeapayment',
        ONETIME_SUCCESS: 'one time:success',
        ONETIME_PENDING: 'one time:pending',
        ONETIME_REVIEW: 'makeapayment:onetime',
        PAYOFF_REVIEW: 'makeapayment:payoff'
    },
    AUTOPAY: {
        EDIT: 'edit:autopay',
        ENROLL: 'enroll:autopay',
        MANAGE_AUTOPAY: 'manage autopay',
        TURN_OFF_AUTOPAY: 'turnoffautopay:autopay'
    },
    ONE_CLICK_AUTOPAY: {
        ENROLLED: 'checked',
        UNENROLLED: 'unchecked',
        ONETIME_AUTOPAY: 'one time:autopay'
    },
    MANAGE_PAYMENT_METHOD: {
        ADD_PAYMENT_METHOD: addPaymentMethod,
        REMOVE_PAYMENT_METHOD: 'remove payment method'
    },
    PAYMENT_PENDING: {
        SECURED_INSTALLMENT: 'secured installment'
    }
};
export const PaymentMethodToPageSubFunctionText = {
    CHECKING: SUB_FUNCTION.PAYMENT_METHOD.ADD_PAYMENT_METHOD_CHECKING,
    SAVINGS: SUB_FUNCTION.PAYMENT_METHOD.ADD_PAYMENT_METHOD_SAVINGS,
    PINLESS_DEBIT_CARD: SUB_FUNCTION.PAYMENT_METHOD.ADD_PAYMENT_METHOD_DEBIT,
    CREDIT_CARD: SUB_FUNCTION.PAYMENT_METHOD.ADD_PAYMENT_METHOD_CREDIT
};
/**
 * Return the page name tags
 */
export const PAGE_NAME = {
    START: 'start',
    COMPLETE: 'complete',
    VIEW: 'view',
    MAKE_PAYMENT: {
        FAILED: 'failed',
        PENDING: 'pending',
        ONETIME_PENDING: 'autopay:success',
        REVIEW_CHECKING: 'review:checking',
        REVIEW_SAVINGS: 'review:savings',
        REVIEW_DEBIT: 'review:debit',
        REVIEW_CREDIT: 'review:credit'
    },
    PAYMENT_METHOD: {
        ADD_PAYMENT_METHOD_CHECKING_ERROR: 'error:checking',
        ADD_PAYMENT_METHOD_SAVINGS_ERROR: 'error:savings',
        ADD_PAYMENT_METHODS_CREDIT_ERROR: 'error:creditcard',
        ADD_PAYMENT_METHODS_DEBIT_ERROR: 'error:debitcard'
    },
    AUTOPAY: {
        FAILED: 'failure',
        SUCCESS: 'success',
        AUTOPAY_FAILURE: 'autopay:failure',
        COMPLETE: {
            CHECKING: 'complete:checking',
            SAVINGS: 'complete:savings',
            DEBIT: 'complete:debit',
            CREDIT: 'complete:credit'
        }
    },
    ONE_CLICK_AUTOPAY: {
        AUTOPAY_START: 'one click autopay:start'
    },
    ACTIVITY: {
        VIEW_DETAIL: 'view detail'
    },
    MANAGE_PAYMENT_METHOD: {
        CONFIRMATION: 'confirmation',
        ERROR: 'error',
        START: 'start'
    },
    PAYMENT_PENDING: {
        ONE_TIME: 'one time:payment pending'
    }
};
/**
 * Analytics messages
 */
export const MESSAGES = {
    ERROR: {
        MAKE_PAYMENT: {
            PAYMENT_FAILED: 'paymentFailed'
        }
    }
};
/**
 * Analytics data analytics
 */
export const DATA_ANALYTICS = {
    CLICK_TRACKING_EVENT: 'clicktrackingevent'
};
/**
 * Analytics data reason
 */
export const DATA_REASON = {
    MAKE_A_PAYMENT_HEADER: {
        X_BUTTON_HEADER: 'x button header'
    },
    MANAGE_PAYMENT_METHODS: {
        ADD_PAYMENT_METHOD_BODY: 'add payment method body',
        ADD_PAYMENT_METHOD_FOOTER: 'add payment method footer',
        ADD_PAYMENT_METHOD_CANCEL: `${SUB_FUNCTION.MANAGE_PAYMENT_METHOD.ADD_PAYMENT_METHOD}:cancel`,
        REMOVE_PAYMENT_METHOD_CANCEL: `${SUB_FUNCTION.MANAGE_PAYMENT_METHOD.REMOVE_PAYMENT_METHOD}:cancel`,
        REMOVE_PAYMENT_METHOD_REMOVE: `${SUB_FUNCTION.MANAGE_PAYMENT_METHOD.REMOVE_PAYMENT_METHOD}:remove:`,
        X_BUTTON_BODY: 'x button body',
        YES_REMOVE_PAYMENT_METHOD: 'yes remove payment method'
    },
    PAYMENT_METHOD: {
        ADD_PAYMENT_METHOD_CHECKING_ERROR: 'add payment method checking error',
        ADD_PAYMENT_METHOD_CHECKING: 'add payment method checking',
        ADD_PAYMENT_METHOD_CREDIT_ERROR: 'FPO: add payment method credit error',
        ADD_PAYMENT_METHOD_CREDIT: 'add payment method credit card',
        ADD_PAYMENT_METHOD_DEBIT_ERROR: 'FPO: add payment method debit error',
        ADD_PAYMENT_METHOD_DEBIT: 'add payment method debit card',
        ADD_PAYMENT_METHOD_SAVINGS_ERROR: 'add payment method savings error',
        ADD_PAYMENT_METHOD_SAVINGS: 'add payment method savings',
        ADD_PAYMENT_METHOD: addPaymentMethod,
        MANAGE_PAYMENT_METHOD: 'manage payment method'
    },
    CLOSE: {
        ONE_TIME: {
            SUCCESS: 'close',
            PENDING: 'pending:close'
        },
        AUTOPAY: {
            SUCCESS: 'onetime autopay success:close',
            FAILED: 'onetime success:close',
            PENDING_SUCCESS: 'autopay:success:close',
            PENDING_FAILED: 'autopay:failed:close'
        }
    },
    AUTOPAY_BANNER: {
        EXPAND: 'autopay banner:expand',
        COLLAPSE: 'autopay banner:collapse'
    },
    PAYMENT_TYPE: {
        ONE_TIME: 'payment type onetime',
        AUTOPAY: 'payment type autopay',
        PAYOFF: 'payment type payoff'
    },
    PAYMENT_AMOUNT: {
        OTHER_AMOUNT: 'other amount'
    }
};
export const DATA_TYPE = {
    MAKE_A_PAYMENT: 'make a payment'
};
export const DATA_OBJECT = {
    BUTTON: 'button',
    LIST: 'list',
    CLICK: 'click',
    LINK: 'link'
};
